export function banner(type = 'error', title = false, subtitle = false, nextFocus = false) {
	document.dispatchEvent(new CustomEvent('displayBanner', {
	    detail: {
	        bannerType: type,
	        bannerTitle: title,
	        bannerSubtitle: subtitle,
	        nextFocus: nextFocus,
	    },
	}));
};

export function openDsfrModal(id) {
	const opener = document.querySelector('[aria-controls="' + id + '"]:not(.close-modal):not(.fr-link--close)');

	if (opener) {
		opener.dispatchEvent(new Event('click'));
	}
};

export function closeDsfrModal(id) {
	const closer = document.querySelector('dialog#' + id + ' .fr-link--close');

	if (closer) {
		closer.dispatchEvent(new Event('click'));
	}
};